export enum RoleType {
    ADMIN = 'admin',
    USER = 'user',
}



// WEBPACK FOOTER //
// ./src/shared/enum/role-type.ts